import { flexRender } from '@tanstack/react-table'
import { LensTypes } from '../../../lib/enums'
import { SiteDesignGetPayload } from '../../../lib/types'
import { CameraGroupTableInitialization } from '../CameraGroupTable/CameraGroupTableInitialization'
import { useState } from 'react'
import React from 'react'

const CamerasGroupTablePdf = ({ siteDesignPayload }: CameraGroupTableProps) => {
  const { cameraRecordings, pdfTableColumns } = CameraGroupTableInitialization(siteDesignPayload)
  let previousCameraGroupId = 0

  const setCameraGroupCssClasses = cameraRow => {
    let cssClasses = 'xsd-proposals-pdf__row d-flex'

    const isCameraMultiLenseCameraGroup = cameraRow.cameraGroupId !== previousCameraGroupId && cameraRow.lensType === LensTypes.MultiLensParent
    const isCameraMultiLenseSubStreams = cameraRow.cameraGroupId === previousCameraGroupId && cameraRow.lensType === LensTypes.MultiLensParent

    cssClasses += isCameraMultiLenseCameraGroup ? ' xsd-proposals-pdf__row--multilines' : ''
    cssClasses += isCameraMultiLenseSubStreams ? ' xsd-proposals-pdf__row--multilines-sub-row' : ''

    // Update the previous group ID for the next iteration
    previousCameraGroupId = cameraRow.cameraGroupId

    return cssClasses
  }

  return (
    <div className="px-10">
      <div className="msds-text-header-5 msds-text-clear-blue py-4 mt-5">Camera Information</div>
      {cameraRecordings && pdfTableColumns && (
        <>
          <div className="xsd-proposals-pdf__calculation-header pb-4 d-flex">
            {pdfTableColumns.map((column, index) => (
              <div className="xsd-proposals-pdf__calculation-header-cell msds-text-body-5-bold text-uppercase" key={index}>
                {column?.header}
              </div>
            ))}
          </div>
          {cameraRecordings.map((cameraRow, index) => (
            <React.Fragment key={`cameraGroup-${cameraRow.id}-${index}`}>
              <div className={setCameraGroupCssClasses(cameraRow)}>
                {pdfTableColumns.map((column, columnIndex) => (
                  <div className="xsd-proposals-pdf__calculation-body-cell msds-text-body-5" key={cameraRow.id + columnIndex}>
                    {flexRender(column.cell, { row: cameraRow, column })}
                  </div>
                ))}
              </div>
              {cameraRow?.streamName && (
                <div className="xsd-proposals-pdf__sub-row msds-text-body-5" key={cameraRow?.id + index + 'subrow'}>
                  {cameraRow?.streamName}
                </div>
              )}
            </React.Fragment>
          ))}
        </>
      )}
    </div>
  )
}
//{renderCameraRows()}

type CameraGroupTableProps = {
  siteDesignPayload: SiteDesignGetPayload
}

export default CamerasGroupTablePdf
